import React from 'react';
import { useFetch } from '../hooks/useFetch';
import {
  OutlinedInput,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material/';
import format from 'date-fns/format';
export default function SelectConsult({ consultId, setConsultId }) {
  const { error, isPending, data } = useFetch(
    'https://pcapi.bi-oss.co.za/consultations/available',
  );
  return (
    <FormControl fullWidth>
      <InputLabel id="selectcountry">Select Date and Time*</InputLabel>

      <Select
        labelId="consultId"
        id="consultId"
        onChange={(e) => setConsultId(e.target.value)}
        input={<OutlinedInput label="selectcountry" />}
        required
        value={consultId}
      >
        {!error &&
          !isPending &&
          data &&
          data.map((data) => (
            <MenuItem key={data.id} value={data.id}>
              Date:{format(new Date(data.availableDate), 'dd/MM/yyyy')} || Time:{' '}
              {data.startTime} - {data.endTime}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
